export const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  audience: process.env.REACT_APP_AUTH0_AUDIENCE
};

export const webApiConfig = {
  baseUri: {
    bff: process.env.REACT_APP_BFF_URL
  }
};

export const basename = process.env.REACT_APP_BASENAME
